import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from './useUniversalNavContext';
const infinitize = (num) => (num === -1 ? Infinity : Number(num));
const prepareEntitlementsData = (rawData) => {
    const output = {
        limits: {
            isAlertsCenterEnabled: rawData.limits.is_alerts_center_enabled,
            isAnalyticsDashboardEnabled: rawData.limits.is_analytics_dashboard_enabled,
            payPerTaskEnabled: rawData.limits.pay_per_task_enabled,
            isApprovalRequestsEnabled: rawData.limits.is_approval_requests_enabled,
        },
        quotas: {
            tasks: {
                count: rawData.quotas.tasks.count,
                limit: infinitize(rawData.quotas.tasks.limit),
            },
        },
    };
    return output;
};
export const useQueryEntitlements = (currentAccountId) => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['entitlements', currentAccountId],
        queryFn: async () => {
            if (!currentAccountId) {
                return undefined;
            }
            const encodedAccountId = encodeURIComponent(currentAccountId);
            const url = new URL(`/api/v4/accounts/${encodedAccountId}/entitlements`, apiHostname || window.location.origin);
            const response = await fetch(url.toString(), {
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            return json;
        },
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60,
        select: prepareEntitlementsData,
        enabled: !!currentAccountId,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryEntitlements.js.map
// @zapier/universal-layout@9.14.1 (2aac35652)
